/**
 * The five capability priority levels (optum-agent Feature 87, D8), named
 * once for the plugin page's picker, the cards' badge, and the Settings
 * default.
 */
import type { CapabilityLevel } from '@optum/api-client/types';

export const LEVELS: readonly CapabilityLevel[] = ['highest', 'high', 'normal', 'low', 'lowest'];

export const LEVEL_LABEL: Record<CapabilityLevel, string> = {
  highest: 'Highest',
  high: 'High',
  normal: 'Normal',
  low: 'Low',
  lowest: 'Lowest',
};

/** The picker's options, highest first. */
export const LEVEL_OPTIONS = LEVELS.map((level) => ({ value: level, label: LEVEL_LABEL[level] }));

/** Whether `value` names a level, for a picker that hands back a string. */
export function isLevel(value: string): value is CapabilityLevel {
  return (LEVELS as readonly string[]).includes(value);
}
